import {
    FETCH_MAIN_PRIVILEGES_REQUEST,
    FETCH_MAIN_PRIVILEGES_SUCCESS,
    FETCH_MAIN_PRIVILEGES_FAILURE,
    FETCH_PRIVILEGE_DETAILS_REQUEST,
    FETCH_PRIVILEGE_DETAILS_SUCCESS,
    FETCH_PRIVILEGE_DETAILS_FAILURE,
    ADD_PRIVILEGE_REQUEST,
    ADD_PRIVILEGE_SUCCESS,
    ADD_PRIVILEGE_FAILURE,
    UPDATE_PRIVILEGE_REQUEST,
    UPDATE_PRIVILEGE_SUCCESS,
    UPDATE_PRIVILEGE_FAILURE,
    DELETE_PRIVILEGE_REQUEST,
    DELETE_PRIVILEGE_SUCCESS,
    DELETE_PRIVILEGE_FAILURE
} from '../actions/PrivilegeAction';

const initialState = {
    mainPrivileges: [],
    currentPrivilege: null,
    loading: false,
    error: null
};

const privilegeReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MAIN_PRIVILEGES_REQUEST:
        case FETCH_PRIVILEGE_DETAILS_REQUEST:
        case ADD_PRIVILEGE_REQUEST:
        case UPDATE_PRIVILEGE_REQUEST:
        case DELETE_PRIVILEGE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_MAIN_PRIVILEGES_SUCCESS:
            return {
                ...state,
                loading: false,
                mainPrivileges: action.payload,
                error: null
            };

        case FETCH_PRIVILEGE_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                currentPrivilege: action.payload,
                error: null
            };

        case ADD_PRIVILEGE_SUCCESS:
        case UPDATE_PRIVILEGE_SUCCESS:
        case DELETE_PRIVILEGE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };

        case FETCH_MAIN_PRIVILEGES_FAILURE:
        case FETCH_PRIVILEGE_DETAILS_FAILURE:
        case ADD_PRIVILEGE_FAILURE:
        case UPDATE_PRIVILEGE_FAILURE:
        case DELETE_PRIVILEGE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default privilegeReducer;
